import * as React from 'react';
import * as styles from "./NavigationBar.css";
import { AppStore } from '../stores';
import { inject, observer } from 'mobx-react';
import { IAIcon } from '../../icon/Icon';
import { Environment } from '../../../services/Environment';
import { Helper } from '../../../Helper';
import { IASpinner } from '../../spinner/Spinner';
import NativeService from '../../../services/NativeService';

export interface INavigationBarProps {
  store?: AppStore;
}

export interface INavigationBarState {
  logoLoaded: string;
  isLoadingLogo: boolean;
  readyCalled: boolean;
}

@inject('store')
@observer
export class NavigationBar extends React.Component<INavigationBarProps, INavigationBarState> {
  constructor(props){
    super(props);
    this.state = {
      logoLoaded: undefined,
      isLoadingLogo: false,
      readyCalled: false
    }
  }

  componentDidUpdate(): void {
    if (this.state.logoLoaded !== this.props.store?.instance?.settings?.design?.logo) {
      this.setState({
        logoLoaded: this.props.store?.instance?.settings?.design?.logo,
        isLoadingLogo: true
      });
    }
  }

  private isAppReady(): void {
    if (!this.state.readyCalled) {
      if (document.getElementById("IA_NavigationBar")) {
        this.setState({readyCalled: true});
        NativeService.ready();
      } else {
        setTimeout(() => {
          this.forceUpdate();
        }, 500);
      }
    }
  }


  public render(): JSX.Element {
    let navigationBarHeight;
    let menuMarginTop;
    if (window.platform === "android") {
      navigationBarHeight = 50;
      menuMarginTop = 5;
    } else {
      navigationBarHeight = this.props.store.isIPhoneXType ? 90 : 70;
      menuMarginTop = this.props.store.isIPhoneXType ? 45 : 25;
    }
    const logo = this.props.store.instance.settings.design.logo ? (this.props.store.instance.settings.design.logo.indexOf("sharepoint.com") !== -1 ? Helper.getImageUrl(
      Environment.getEnvironmentForImageAPI(this.props.store.environment),
        this.props.store.tenant.replace('.sharepoint.com', ''),
        this.props.store.token,
        this.props.store.instance.settings.design.logo,
        this.props.store.instance.modified ? this.props.store.instance.modified.toString().replace(/[^\d]/g, '') : undefined,
        undefined, undefined, this.props.store.instance.modified ? true : false,
        true
      ) : this.props.store.instance.settings.design.logo)
      :
      "none";
      this.isAppReady();
    return (
      <div
        id="IA_NavigationBar"
        className={styles.IA_navigationBar}
        style={{
          backgroundColor: this.props.store.instance.settings.design.navigationBarColor,
          height: navigationBarHeight
        }}
      >
        {this.props.store.instance.settings.design.menuStyle === "Burger" && (this.props.store.instance.settings.menu.length > 1 || this.props.store.preview) &&
          <div
            className={styles.IA_burgerMenuButton}
            style={{
              marginTop: menuMarginTop
            }}
            onClick={() => {
              this.props.store.showMenu = true;
            }}
          >
            <IAIcon
              title={"BurgerMenu"}
              size={18}
              color={this.props.store.instance.settings.design.navigationBarContentColor}
              style={{
                width: 18,
                height: 18
              }}
            />
          </div>
        }
        <div
          className={styles.IA_logo}
          style={{
            backgroundImage: `url(${logo})`,
            top: menuMarginTop + 5,
            marginLeft: this.props.store.instance.settings.design.menuStyle === "TabBar" ? 90 : (this.props.store.instance.settings.menu.length < 2 && !this.props.store.preview) ? 90 : 50,
            color: this.props.store.instance.settings.design.navigationBarContentColor,
            opacity: this.props.store.preview && this.state.isLoadingLogo && logo !== "none" ? 0 : 1
          }}
          onClick={() => {
            this.props.store.selectedPageIndex = 0;
            document.getElementById("IA_contentArea").scrollTop = 0
          }}
        >
          {this.props.store.instance.settings.design.logo ? "" : this.props.store.instance.title}
        </div>
        {this.props.store.preview && this.props.store.instance.settings.design.logo &&
            <>
              <img
                style={{
                  display: "none"
                }}
                src={logo}
                onLoad={() => {
                  this.setState({
                    logoLoaded: this.props.store?.instance?.settings?.design?.logo,
                    isLoadingLogo: false
                  });
                }}
              />
              {this.state.isLoadingLogo && 
                <IASpinner
                  color={this.props.store.instance.settings.design.navigationBarContentColor}
                  style={{
                    position: "absolute",
                    top: menuMarginTop + 5,
                    left: "calc(50% - 15px)",
                    margin: 0
                  }}
                />
              }
            </>
          }
        <div
          className={styles.IA_burgerMenuButton}
          style={{
            marginTop: menuMarginTop,
            float: "right",
            marginRight: 10,
            opacity: this.props.store.preview ? 0.3 : 1,
            cursor: this.props.store.preview ? "default" : "pointer"
          }}
          onClick={() => {
            this.props.store.preview ? {} : this.props.store.reloadPage();
          }}
        >
          <IAIcon
            title={"Refresh"}
            size={18}
            color={this.props.store.instance.settings.design.navigationBarContentColor}
            style={{
              width: 18,
              height: 18
            }}
          />
        </div>
        <div
          className={styles.IA_burgerMenuButton}
          style={{
            marginTop: menuMarginTop,
            float: "right",
            opacity: this.props.store.preview || this.props.store.showPowerApp ? 0.3 : 1,
            cursor: this.props.store.preview ? "default" : "pointer"
          }}
          onClick={() => {
            if (!this.props.store.preview && !this.props.store.showPowerApp) {
              this.props.store.showSettings = true;
            }
          }}
        >
          <IAIcon
            title={"Settings"}
            size={18}
            color={this.props.store.instance.settings.design.navigationBarContentColor}
            style={{
              width: 18,
              height: 18
            }}
          />
        </div>
      </div >
    );
  }
}